<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <ClientsTable :units="units"
          @unit-deleted="fetchProducts"/>
        </div>
      </div>

    </div>
</template>

<script>
import axios from "axios";
import ClientsTable from "./components/Table.vue";
const companyId = localStorage.getItem('companyId');
export default {
    name: "Units",
    components: {
        ClientsTable,
    },
    data() {
        return {
            units:[],
        };
    },
    methods:{
        async fetchProducts(){
            let self=this;
            const token = localStorage.getItem("accessToken");
            const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': '*/*',
                        'Authorization':`Bearer ${token}`
                    }
                };
            axios.get(this.$store.state.apiURL+'units?company='+companyId,config)
            .then((result)=>{
                console.log(result);
                this.units=result.data;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            });
        }
    },
    mounted() {
        this.fetchProducts();
    },
};
</script>
